module.exports = function getResource(label, vars = []) {
    let resources = {
        min: 'min'
    };

    return resources[label];
};
